import store from '../store'
import getApiClient from "../plugins/api";

function loadCustomPages() {
  const api = getApiClient(store),
    pages = []

  return new Promise((resolve, reject) => {
    api.get('/pages')
      .then(result => {
        result.data['hydra:member'].forEach((item) => {
          pages.push({
            _name: 'CSidebarNavItem',
            name: item.menuName,
            icon: item.icon || undefined,
            to: `/page/${item.slug}`
          })
        })

        resolve(pages)
      })
  })
}

function updateNavigationRoutes() {
  let agencyRoutes = [
      {
        _name: 'CSidebarNavItem',
        name: 'Início',
        to: '/dashboard',
        icon: 'cil-speedometer'
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Trips',
        route: '/trips',
        icon: 'cil-pencil',
        items: [
          {
            name: 'Minhas Trips',
            to: '/trips/list'
          },
          {
            name: 'Criar Trip',
            to: '/trips/new'
          }
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Impulsionamento',
        route: '/ads',
        icon: 'cil-comment-square',
        items: [
          {
            name: 'Impulsionar',
            to: '/ads'
          },
          {
            name: 'Minhas compras',
            to: '/boosts'
          }
        ]
      }
    ],

    sellingAgencyRoutes = [
      {
        _name: 'CSidebarNavDropdown',
        name: 'Clientes',
        route: '/customers',
        icon: 'cil-people',
        items: [
          {
            name: 'Criar cliente',
            to: '/customers/create'
          },
          {
            name: 'Meus clientes',
            to: '/customers/list'
          }
        ]
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Termos de aceite',
        to: '/selling_process',
        icon: 'cil-list'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Pedidos',
        to: '/agency/orders',
        icon: 'cil-cart'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Minhas avaliações',
        to: '/received_surveys',
        icon: 'cil-star'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Valores a receber',
        to: '/agency/payables',
        icon: 'cil-dollar'
      }
    ],

    notSellingAgencyRoutes = [
      {
        _name: 'CSidebarNavItem',
        name: 'Reservas',
        to: '/agency/reservations',
        icon: 'cil-calendar'
      }
    ],

    customerRoutes = [
      {
        _name: 'CSidebarNavItem',
        name: 'Meus pedidos',
        to: '/orders',
        icon: 'cil-cart'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Minhas avaliações',
        to: '/surveys',
        icon: 'cil-star'
      }
    ],

    serviceRoutes = [
      {
        _name: 'CSidebarNavItem',
        name: 'Usuários',
        to: '/users',
        icon: 'cil-user'
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Agências',
        route: '/agencies',
        icon: 'cil-people',
        items: [
          {
            name: 'Listar agências',
            to: '/agencies'
          },
          {
            name: 'Recados',
            to: '/posts/list'
          },
        ]
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Pedidos',
        to: '/orders/all',
        icon: 'cil-dollar'
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Relatórios',
        route: '#',
        icon: 'cil-star',
        items: [
          {
            name: 'Carrinhos abandonados',
            to: '/abandoned_carts',
          },
          {
            name: 'Avaliações não respondidas',
            to: '/pending_surveys'
          },
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Gestão',
        route: '#',
        icon: 'cil-cog',
        items: [
          {
            _name: 'CSidebarNavItem',
            name: 'Meus Clientes',
            to: '/customers/list',
            icon: 'cil-people',
          },
        ]
      },
    ],

    adminRoutes = [
      {
        _name: 'CSidebarNavDropdown',
        name: 'Relatórios',
        route: '#',
        icon: 'cil-chart-line',
        items: [
          {
            name: 'Resumo',
            to: '/highlight_report',
          },
          {
            name: 'Carrinhos abandonados',
            to: '/abandoned_carts',
          },
          {
            name: 'Avaliações não respondidas',
            to: '/pending_surveys'
          },
          {
            name: 'Valores a repassar',
            to: '/payables',
          }
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Gestão',
        route: '#',
        icon: 'cil-cog',
        items: [
          {
            _name: 'CSidebarNavItem',
            name: 'Meus Clientes',
            to: '/customers/list',
            icon: 'cil-people',
          },
          {
            _name: 'CSidebarNavItem',
            name: 'Locais de embarque',
            to: '/boarding_places',
            icon: 'cil-location-pin',
          },
          {
            _name: 'CSidebarNavItem',
            name: 'Categorias de destinos',
            icon: 'cil-map',
            to: '/categories',
          },
          {
            _name: 'CSidebarNavItem',
            name: 'Destinos',
            icon: 'cil-map',
            to: '/places'
          },
          {
            _name: 'CSidebarNavItem',
            name: 'Feriados',
            icon: 'cil-calendar',
            to: '/holidays',
          },
          {
            _name: 'CSidebarNavItem',
            name: 'Termos de aceite',
            to: '/terms',
            icon: 'cil-list'
          },
          {
            _name: 'CSidebarNavItem',
            name: 'Listar páginas',
            to: '/pages',
            icon: 'cil-short-text'
          },
          {
            _name: 'CSidebarNavItem',
            name: 'Cupons de desconto',
            to: '/coupons',
            icon: 'cil-tag'
          },
          {
            _name: 'CSidebarNavItem',
            name: 'Configurações',
            to: '/settings',
            icon: 'cil-cog'
          },
        ]
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Compras de impulsionamento',
        to: '/boosts_report',
        icon: 'cil-comment-square'
      },
    ]

  let availableRoutes = []

  if (store.state.user && store.state.user.id) {
    let userRole = store.state.user.roles[0]

    switch (userRole) {
      case 'ROLE_SERVICE':
        availableRoutes.push(...serviceRoutes)
        break;
      case 'ROLE_ADMIN':
        availableRoutes.push(...serviceRoutes.filter(route => {
          return !['Relatórios', 'Gestão'].includes(route.name)
        }))
        availableRoutes.push(...adminRoutes)
        loadCustomPages().then(pages => {
          availableRoutes.push(...pages)
        })
        break;
      case 'ROLE_AGENCY':
        availableRoutes.push(...agencyRoutes)
        if (!store.state.user?.agency?.cart) {
          availableRoutes.push(...notSellingAgencyRoutes)
        } else {
          availableRoutes.push(...sellingAgencyRoutes)
        }

        loadCustomPages().then(pages => {
          availableRoutes.push(...pages)
        })
        break;
      case 'ROLE_CUSTOMER':
        availableRoutes.push(...customerRoutes)
        break;
    }
  }

  let routes = [
    {
      _name: 'CSidebarNav',
      _children: availableRoutes
    }
  ]

  store.commit('setNavigationRoutes', routes)
}

export default updateNavigationRoutes
